module.exports = __webpack_public_path__ + "img/tokyo-sauna.68fbb7a1.svg";